export default "__VITE_ASSET__7kvbQKjp__"